/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordValidationRuleName } from './PasswordValidationRuleName';
import {
    PasswordValidationRuleNameFromJSON,
    PasswordValidationRuleNameFromJSONTyped,
    PasswordValidationRuleNameToJSON,
} from './PasswordValidationRuleName';
import type { PatternMatchType } from './PatternMatchType';
import {
    PatternMatchTypeFromJSON,
    PatternMatchTypeFromJSONTyped,
    PatternMatchTypeToJSON,
} from './PatternMatchType';
import type { PatternQualifier } from './PatternQualifier';
import {
    PatternQualifierFromJSON,
    PatternQualifierFromJSONTyped,
    PatternQualifierToJSON,
} from './PatternQualifier';

/**
 * 
 * @export
 * @interface RegexPasswordValidationRule
 */
export interface RegexPasswordValidationRule {
    /**
     * 
     * @type {PasswordValidationRuleName}
     * @memberof RegexPasswordValidationRule
     */
    name: PasswordValidationRuleName;
    /**
     * 
     * @type {string}
     * @memberof RegexPasswordValidationRule
     */
    pattern: string;
    /**
     * 
     * @type {PatternMatchType}
     * @memberof RegexPasswordValidationRule
     */
    match_type: PatternMatchType;
    /**
     * 
     * @type {Array<PatternQualifier>}
     * @memberof RegexPasswordValidationRule
     */
    pattern_qualifiers?: Array<PatternQualifier>;
}

/**
 * Check if a given object implements the RegexPasswordValidationRule interface.
 */
export function instanceOfRegexPasswordValidationRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "pattern" in value;
    isInstance = isInstance && "match_type" in value;

    return isInstance;
}

export function RegexPasswordValidationRuleFromJSON(json: any): RegexPasswordValidationRule {
    return RegexPasswordValidationRuleFromJSONTyped(json, false);
}

export function RegexPasswordValidationRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegexPasswordValidationRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': PasswordValidationRuleNameFromJSON(json['name']),
        'pattern': json['pattern'],
        'match_type': PatternMatchTypeFromJSON(json['match_type']),
        'pattern_qualifiers': !exists(json, 'pattern_qualifiers') ? undefined : ((json['pattern_qualifiers'] as Array<any>).map(PatternQualifierFromJSON)),
    };
}

export function RegexPasswordValidationRuleToJSON(value?: RegexPasswordValidationRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': PasswordValidationRuleNameToJSON(value.name),
        'pattern': value.pattern,
        'match_type': PatternMatchTypeToJSON(value.match_type),
        'pattern_qualifiers': value.pattern_qualifiers === undefined ? undefined : ((value.pattern_qualifiers as Array<any>).map(PatternQualifierToJSON)),
    };
}

